import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Message} from 'epic-diesel-common';
import StatisticBox from '../../common/StatisticBox';
import styles from './EarningSection.pcss';
import EarningStatistic from './EarningStatistic';

export default class EarningSection extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        sectionData: PropTypes.object,
        affiliateAccount: PropTypes.object
    };

    static defaultProps = {
        sectionData: {}
    };

    render() {
        const earnings = this.props.sectionData || {};
        const {affiliateAccount} = this.props;

        const slugEntry = (
            <div className={styles.affiliateSlugText}>
                <span title={affiliateAccount.slug}>{affiliateAccount.slug}</span>
            </div>
        );

        return (
            <div className={classNames(styles.section, this.props.className)}>
                <EarningStatistic
                    title="epic.affiliate.earnings.my_creator_tag.title"
                    tipTitle="epic.affiliate.earnings.my_earnings.tag_tip">
                    <StatisticBox
                        type="text"
                        content={slugEntry}
                        subTitle=""
                        className={styles.affiliateSlugContainer}
                    />
                </EarningStatistic>
                <EarningStatistic
                    title="epic.affiliate.earnings.my_earnings.tooltip.total_earnings.title"
                    tipTitle="epic.affiliate.earnings.my_earnings.tooltip.total_earnings.subtext">
                    {earnings.totalEarnings !== null ? (
                        <StatisticBox
                            type="currency"
                            content={earnings.totalEarnings}
                            code={earnings.lastPayoutCurrency}
                        />
                    ) : (
                        <StatisticBox
                            type="text"
                            content={<Message code="epic.affiliate.earnings.statistics.error" />}
                        />
                    )}
                </EarningStatistic>
                <EarningStatistic
                    title="epic.affiliate.earnings.my_earnings.tooltip.balance.title"
                    tipTitle="epic.affiliate.earnings.my_earnings.tooltip.balance.subtext">
                    {earnings.totalEarnings !== null ? (
                        <StatisticBox
                            type="currency"
                            content={earnings.balance}
                            code={earnings.balanceCurrency}
                        />
                    ) : (
                        <StatisticBox
                            type="text"
                            content={<Message code="epic.affiliate.earnings.statistics.error" />}
                        />
                    )}
                    <div className={styles.extra}>
                        <Message code="epic.affiliate.earnings.my_earnings.tooltip.balance.extra" />
                    </div>
                </EarningStatistic>
                <EarningStatistic
                    title="epic.affiliate.earnings.my_earnings.tooltip.last_payout.title"
                    tipTitle="epic.affiliate.earnings.my_earnings.tooltip.last_payout.subtext">
                    {earnings.lastPayout !== null ? (
                        <StatisticBox
                            type="currency"
                            content={earnings.lastPayout}
                            code={earnings.totalEarningsCurrency}
                        />
                    ) : (
                        <StatisticBox
                            type="text"
                            content={<Message code="epic.affiliate.earnings.statistics.error" />}
                        />
                    )}
                    <div className={styles.extra}>
                        <Message code="epic.affiliate.earnings.my_earnings.tooltip.last_payout.extra" />
                    </div>
                </EarningStatistic>
            </div>
        );
    }
}
